import styled from "styled-components";
import React from "react";
import { Grid } from "semantic-ui-react";
import { FinanceGlobalStats } from "./globalstats";

const PageContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const FinancePageComponent = () => {
  return (
    <div>
      <FinanceGlobalStats />
    </div>
  );
};

export const FinancePage = FinancePageComponent;
